module.exports = __webpack_public_path__ + "media/1_3-1.56099f23.mp3";